import xt from "./custom-event-data.js";
import Ht from "./custom-event-property-data.js";
import Gt from "./filter-set.js";
import Zt from "./in-app-message-click-data.js";
import $t from "./purchase-data.js";
import ts from "./purchase-property-data.js";
import lr from "./push-click-data.js";
import V from "./trigger-events.js";
import r from "../../../shared-lib/braze-shared-lib.js";
export default class Yt {
  constructor(e, t) {
    (this.type = e), (this.data = t);
  }
  ec(e, t) {
    return Yt.tc[this.type] === e && (null == this.data || this.data.Jl(t));
  }
  static gu(e, t) {
    let a = null;
    try {
      a = window.atob(e);
    } catch (t) {
      return (
        r.D.info("Failed to unencode analytics id " + e + ": " + t.message), !1
      );
    }
    return t === a.split("_")[0];
  }
  static fromJson(e) {
    const t = e.type;
    let r;
    switch (t) {
      case Yt.rc.OPEN:
        r = null;
        break;
      case Yt.rc.Rr:
        r = $t.fromJson(e.data);
        break;
      case Yt.rc.ac:
        r = ts.fromJson(e.data);
        break;
      case Yt.rc.vr:
        r = lr.fromJson(e.data);
        break;
      case Yt.rc.be:
        r = xt.fromJson(e.data);
        break;
      case Yt.rc.sc:
        r = Ht.fromJson(e.data);
        break;
      case Yt.rc.Mr:
        r = Zt.fromJson(e.data);
        break;
      case Yt.rc.ks:
        r = null;
    }
    return new Yt(t, r);
  }
  ss() {
    return { t: this.type, d: this.data ? this.data.ss() : null };
  }
  static Pn(e) {
    let t, r;
    switch (e.t) {
      case Yt.rc.OPEN:
        t = null;
        break;
      case Yt.rc.Rr:
        t = new $t(e.d);
        break;
      case Yt.rc.ac:
        (r = e.d || {}), (t = new ts(r.id, Gt.Pn(r.pf || [])));
        break;
      case Yt.rc.vr:
        t = new lr(e.d);
        break;
      case Yt.rc.be:
        t = new xt(e.d);
        break;
      case Yt.rc.sc:
        (r = e.d || {}), (t = new Ht(r.e, Gt.Pn(r.pf || [])));
        break;
      case Yt.rc.Mr:
        t = new Zt(e.d);
        break;
      case Yt.rc.ks:
        t = null;
    }
    return new Yt(e.t, t);
  }
}
(Yt.rc = {
  OPEN: "open",
  Rr: "purchase",
  ac: "purchase_property",
  vr: "push_click",
  be: "custom_event",
  sc: "custom_event_property",
  Mr: "iam_click",
  ks: "test"
}),
  (Yt.tc = {}),
  (Yt.tc[Yt.rc.OPEN] = V.OPEN),
  (Yt.tc[Yt.rc.Rr] = V.Rr),
  (Yt.tc[Yt.rc.ac] = V.Rr),
  (Yt.tc[Yt.rc.vr] = V.vr),
  (Yt.tc[Yt.rc.be] = V.be),
  (Yt.tc[Yt.rc.sc] = V.be),
  (Yt.tc[Yt.rc.Mr] = V.Mr),
  (Yt.tc[Yt.rc.ks] = V.ks);
